import Cookies from 'js-cookie';

const generateHash = (hash) => {
  return `${hash}?${Cookies.get('url.id')}`;
};

export default generateHash;